import React from "react";
import { motion } from "framer-motion";

const EASE = [0.25, 0.1, 0.25, 1];

export const Reveal = ({ children, delay = 0, y = 32, className = "", as = "div" }) => {
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.8, ease: EASE, delay }}
    >
      {children}
    </MotionTag>
  );
};

export const Overline = ({ children, className = "" }) => (
  <span className={`block text-xs sm:text-sm font-medium tracking-[0.25em] uppercase text-[#B0926A] ${className}`}>
    {children}
  </span>
);
